module.exports = __webpack_public_path__ + "static/bett1ACES-1920x890-v2-9b5b116557e437808c51048390828ffb.mp4";